module.exports = __webpack_public_path__ + "img/電気回路_1_9_5.ba657514.png";